import type {Evaluator} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {GuideNode} from "#template/nodes/object/guide/guide-node"
import {z} from "zod/v4-mini"
import type {ObjectNodeDefinition, ObjectNodeParameters} from "#template/nodes/object/types"
import type {OnCompileContext, TemplateNodeContext, VisitorNodeResult} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import {objectNodeParameters} from "#template/nodes/object/validation"
import type {SceneNodes} from "#template/interfaces/scene-object"
import {visitNone} from "#template/template-node/visit-helpers"

export type PointGuideParameters = {
    name: string
} & ObjectNodeParameters

const pointGuideDefinition: ObjectNodeDefinition<PointGuideParameters> = {
    nodeClass: "PointGuide",
    validation: {
        parameters: z.extend(
            z.object({
                name: z.string(),
            }),
            objectNodeParameters.shape,
        ),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGuide extends GuideNode<PointGuideParameters> {
    public override get definition() {
        return pointGuideDefinition
    }

    public override onCompile(context: OnCompileContext, _evaluator: Evaluator<TemplateNodeContext>): VisitorNodeResult<PointGuideParameters> {
        const {evaluator} = context
        const scope = evaluator.getScope(this)

        this.setupObject(scope, context, "Point", undefined, undefined, (objectProps) => {
            return scope.struct<SceneNodes.Point>("Point", {
                type: "Point",
                ...objectProps,
                size: 1,
            })
        })

        return visitNone(this.parameters)
    }
}
